<div class="manage-users-container">

    <div class="header-row">
      <div class="page-title">
        <i class="bi bi-people-fill"></i>
        <span>Manage Users</span>
      </div>

    <button
      mat-raised-button
      color="primary"
      (click)="openInviteDialog()">
      <mat-icon>person_add</mat-icon>
      Invite User
    </button>
  </div>


  <!-- PLATFORM ADMIN VIEW -->
  <ng-container *ngIf="isPlatformAdmin">

    <div *ngFor="let group of tenantGroups" class="tenant-group">

      <div class="tenant-header" (click)="toggleTenant(group)">
        <mat-icon>
          {{ group.expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
        <strong>Tenant:</strong> {{ group.tenant_id }}
        <span class="count">({{ group.users.length }} users)</span>
      </div>

      <table mat-table [dataSource]="group.users" *ngIf="group.expanded">

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let user">{{ user.email }}</td>
        </ng-container>

        <ng-container matColumnDef="full_name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let user">{{ user.full_name }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let user">
            <mat-chip [ngClass]="statusClass(user)">
              {{ statusLabel(user) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let user">
            <button mat-icon-button>
              <mat-icon>mail</mat-icon>
            </button>
          </td>
        </ng-container> -->

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button (click)="resendInvite(user)">
            <mat-icon>mail</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleUser(user)">
            <mat-icon>{{ user.is_active ? 'block' : 'check_circle' }}</mat-icon>
          </button>
        </td>
    </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

    </div>
  </ng-container>

  <!-- TENANT ADMIN VIEW -->
  <ng-container *ngIf="!isPlatformAdmin">

    <table mat-table [dataSource]="users">

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <ng-container matColumnDef="full_name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let user">{{ user.full_name }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let user">
          <mat-chip [ngClass]="statusClass(user)">
            {{ statusLabel(user) }}
          </mat-chip>
        </td>
      </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button (click)="resendInvite(user)">
            <mat-icon>mail</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleUser(user)">
            <mat-icon>{{ user.is_active ? 'block' : 'check_circle' }}</mat-icon>
          </button>
        </td>
    </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

  </ng-container>

</div>
